import React from "react";

export default function Contact() {
  return (
    <div className="flex flex-col justify-center items-center w-screen h-screen bg-[rgb(209,220,223)]">
      <h1 className="text-4xl">Give me a holler!</h1>
      <br></br>
      <h2 className="text-2xl">patrick@patrickwcode.com</h2>
    </div>
  );
}